/**
 * Created by Diana Aglyamutdinova 22.04.2019
 */

/**
 * @class start view of program container Layer
 * @extends pmui.NodeLayer
 * @constructor
 * @param {Number} [hideDuration=pmui.PopupLayer.STANDARD_HIDE_DURATION] Delay before self removing.
 */

pmui.FunctionNode = pmui.NodeLayer.extend(/** @lends pmui.NodeLayer# */{
	_bodyNode: null,
	_params: [],
	_name: null,
	_paramsNumber: 0,
	_cont: null,
	_rBrace: null,
	_lBrace: null,

	ctor: function (treeNode, parent, name)
	{
		this.type = FunctionButton.Type.Function;
		this.isPartlyClonable = true;
		this._name = name;
		if (name !== undefined)
		{
			this._withBorder = true;
		}
		this._super(parent, treeNode);
		this.setLayoutType(ccui.Layout.RELATIVE);

		this._cont = new ccui.Layout();
		this._cont.setLayoutType(ccui.Layout.RELATIVE);

		var text = null;
		text = this.createText("def",pmui.NodeLayer.CONSTR_COLOR);

		this.createALignSome(text, "", "def", ccui.RelativeLayoutParameter.PARENT_LEFT_CENTER_VERTICAL);
		this._cont.addChild(text);

		if (name !== undefined)
		{
			var but = this.createText(LocalizedString(name));
			this.createALignSome(but, "def", "name", ccui.RelativeLayoutParameter.LOCATION_RIGHT_OF_CENTER, pmui.NodeLayer.SEPARATORX, 0, 0, 0);
			this._cont.addChild(but);
		}

		var text1 = this.createText("beg", pmui.NodeLayer.CONSTR_COLOR);

		this.createALignSome(this._cont, "", "begin_", ccui.RelativeLayoutParameter.PARENT_TOP_LEFT, pmui.NodeLayer.SEPARATORX, 0, 0, 0);
		this.createALignSome(text1, "begin_", "beg_", ccui.RelativeLayoutParameter.LOCATION_BELOW_LEFTALIGN);

		this.addChild(text1);
		this.addChild(this._cont);

		this._addTypes = [FunctionButton.Type.Alloc];

		var first = new pmui.NodeLayer(this, null);
		first.setContentSize(100,40);
		first.select = this.paramsSelect;
		first.setName("firstElem" + this._id);
		first._id = this._id + pm.BodyFirstChildTag;
		this.createALignSome(first, "", "first", ccui.RelativeLayoutParameter.PARENT_TOP_LEFT, 50, 0, 0, -40);

		this._params = [];
		this.addChild(first);
		this._params.push(first);

		if(this._name)
			pm.sendCustomEvent(pm.FUNCTION_PARAMS_CHANGED, {name: this._name, params: this._paramsNumber});
	},

	addParameter: function(type)
	{

	},

	getBody: function()
	{
		return this._bodyNode;
	},

	select: function ()
	{
		if (!this._selected)
		{
			this.setBackGroundImage("PiktomirK/select-func-border.png");
			this.setBackGroundImageScale9Enabled(true);
			this.setCascadeOpacityEnabled(false);
			this.setBackGroundImageCapInsets(cc.rect(15, 15, 10, 10));
			this._selected = true;
			this.setTag(ProgramContainerLayer.SELECTED_TAG);
		}
	},

	removeLinks: function ()
	{
		pmui.FunctionNode.vals.delete(this._name);
		pm.sendCustomEvent(pm.FUNCTION_DEFINITION_REMOVED, this._name);
		this.makeCleanUp();
	},

	isFunction: function()
	{
		return true;
	},

	removeLink: function (link)
	{

	},

	getChildrenNodes: function ()
	{
		return this._params.concat([this._bodyNode]);
	},

	clone: function ()
	{
		if (!this.isMain())
			return new VarFunctionButton(FunctionButton.Type.Function, this._name);
	},

	getNodeId: function ()
	{
		if (!this._name)
			return "main";
		return this._name;
	},

	isMain: function ()
	{
		return this._treeNode.isMain();
	},

	highlight: function ()
	{
		if (!this.isMain())
		{
			this.setBackGroundImage("PiktomirK/highlight.png");
			this.setBackGroundImageCapInsets(cc.rect(15, 15, 10, 10));
			this.setBackGroundImageScale9Enabled(true);
			this.setCascadeOpacityEnabled(false);
		}
	},

	addChildNode: function (node)
	{
		if(node._treeNode.getTagName() === pm.BodyTag
			|| node._treeNode.type === pm.data.Node.Type.Body)
		{
			this._bodyNode = node;
			var text2 = this.createText("end", pmui.NodeLayer.CONSTR_COLOR);
			this.createALignSome(this._bodyNode, "beg_", "body_", ccui.RelativeLayoutParameter.LOCATION_BELOW_LEFTALIGN);
			this.createALignSome(text2, "body_", "end_", ccui.RelativeLayoutParameter.LOCATION_BELOW_LEFTALIGN, -ProgramContainerLayer.SEPARATOR_SIZEX, 0, 0, pmui.NodeLayer.SEPARATORY);
			this.addChild(this._bodyNode);
			this.addChild(text2);
			return;
		}
		if (this._paramsNumber === 0)
		{
			this._params.pop();
			this._lBrace = this.createText("(");
			var varValueSpace = pmui.NodeLayer.SEPARATORX * 3;
			if(pmui.NodeLayer.KUMIR_MODE)
				varValueSpace = 0;
			this.createALignSome(this._lBrace, "name", pmui.FunctionNode.L_BRACE_TAG, ccui.RelativeLayoutParameter.LOCATION_RIGHT_OF_CENTER,
				0, 0, 0, 0);
			this.createALignSome(node, pmui.FunctionNode.L_BRACE_TAG, pm.FuncParamTag + "0", ccui.RelativeLayoutParameter.LOCATION_RIGHT_OF_CENTER,
				varValueSpace, pmui.NodeLayer.SEPARATORY, 0, pmui.NodeLayer.SEPARATORY);

			this._rBrace = this.createText(")");
			this._rBrace.setName(pmui.FunctionNode.R_BRACE_TAG);
			this.createALignSome(this._rBrace, "", pmui.FunctionNode.R_BRACE_TAG, ccui.RelativeLayoutParameter.PARENT_RIGHT_CENTER_VERTICAL,
				0, 0, pmui.NodeLayer.SEPARATORX, 0);

			this._cont.addChild(this._lBrace);
			this._cont.addChild(this._rBrace);
		}
		else//first adding of the second and else elems ", 0"
		{
			var comma = this.createText(",");
			this.createALignSome(comma, pm.FuncParamTag + (this._paramsNumber - 1), pmui.CommandNode.COMMAND_COMMA_TAG + this._paramsNumber, ccui.RelativeLayoutParameter.LOCATION_RIGHT_OF_CENTER,
				0, 0, 0, 0);
			this._cont.addChild(comma);

			this.createALignSome(node, pmui.CommandNode.COMMAND_COMMA_TAG + this._paramsNumber, pm.FuncParamTag + this._paramsNumber, ccui.RelativeLayoutParameter.LOCATION_RIGHT_OF_CENTER,
				pmui.NodeLayer.SEPARATORX * 3, pmui.NodeLayer.SEPARATORY, 0, pmui.NodeLayer.SEPARATORY);
		}
		this._cont.addChild(node);
		this._params.push(node);
		this._paramsNumber++;

		this.sizeOfContainer(this._cont);
		//this.calculateSize();

		pm.sendCustomEvent(pm.FUNCTION_PARAMS_CHANGED, {name: this._name, params: this._paramsNumber});
	},

	_removeNode: function (node)
	{
		var parent = this._treeNode;
		parent.removeChild(node._treeNode);
		this._cont.removeAllChildren();

		var text = this.createText("def",pmui.NodeLayer.CONSTR_COLOR);

		this.createALignSome(text, "", "def", ccui.RelativeLayoutParameter.PARENT_LEFT_CENTER_VERTICAL);
		this._cont.addChild(text);

		var but = this.createText(LocalizedString(this._treeNode.value));
		this.createALignSome(but, "def", "name", ccui.RelativeLayoutParameter.LOCATION_RIGHT_OF_CENTER, pmui.NodeLayer.SEPARATORX, 0, 0, 0);
		this._cont.addChild(but);

		this._params.splice(this._params.indexOf(node));
		this._paramsNumber = 0;
		this._treeNode.children.forEach(function (child){
			if(child.type !== pm.data.Node.Type.Body)
				pm.sendCustomEvent(pm.PARSE_NODE, {node: child, parent: this});
		}, this);
		if(this._params.length === 0)
		{
			var first = new pmui.NodeLayer(this, null);
			first.setContentSize(100,40);
			first.select = this.paramsSelect;
			first.setName("firstElem" + this._id);
			first._id = this._id + pm.BodyFirstChildTag;
			this.createALignSome(first, "", "first", ccui.RelativeLayoutParameter.PARENT_TOP_LEFT, 50, 0, 0, -40);

			this.addChild(first);
			this._params.push(first);
		}
		pm.sendCustomEvent(pm.FUNCTION_PARAMS_CHANGED, {name: this._name, params: this._paramsNumber});
	},

	canAdd: function(element)
	{
		if(this.isMain())
			return false;
		else {
			return pmui.NodeLayer.prototype.canAdd.call(this, element);
		}
	},

	paramsSelect: function ()
	{
		if (!this._selected)
		{
			this.setBackGroundImage("PiktomirK/select-border.png");
			this.setBackGroundImageScale9Enabled(true);
			this.setCascadeOpacityEnabled(false);
			this.setBackGroundImageCapInsets(cc.rect(15, 15, 10, 10));
			this._selected = true;
			this.setTag(ProgramContainerLayer.SELECTED_TAG);
		}
	},

	getNextParamName: function (type)
	{
		if (type === pm.AllocVals.INT)
		{
			var alfabet = "п";
			var name = alfabet + this._paramsNumber;
			return name;
		}
		else
		{
			var alfabet = "п";
			var name = alfabet + this._paramsNumber;
			return name;
		}
	},

	isFunction: function ()
	{
		return true;
	},

	calculateSize: function (forPar)
	{
		this.sizeOfContainer(this._cont);
		var size = this.sizeOfVContainer(this, true);
		this.setContentSize(size.width + ProgramContainerLayer.SEPARATOR_SIZEX, size.height);
		if (!forPar)
			this._parentNode.calculateSize();
	}
});

pmui.FunctionNode.vals = new SetClass([
]);
pmui.FunctionNode.piktoVals = new SetClass([
	pm.CMD_A,
	pm.CMD_B,
	pm.CMD_C,
	pm.CMD_D,
	pm.CMD_E
]);
pmui.FunctionNode.L_BRACE_TAG = "lbracetag";
pmui.FunctionNode.R_BRACE_TAG = "rbracetag";

